// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import Cookies from "js-cookie";
// import { useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import {
//     updateItemQuantity,
//     addToCart,
//     fetchCart,
// } from "../../../redux/thunks/cartThunks";
// import {
//     fetchWishlist,
//     addItemToWishlist,
//     removeItemFromWishlist,
// } from "../../../redux/thunks/wishlistThunks";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import {
//     AiOutlineHeart,
//     AiFillHeart,
//     AiOutlineShoppingCart,
//     AiOutlineLeft,
//     AiOutlineRight,
// } from "react-icons/ai";
// import { BsStarFill, BsStarHalf, BsStar, BsStars } from "react-icons/bs";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { PulseLoader } from "react-spinners";
// import fallbackImage from "../../../assets/brand-default.jpg";
// import { globalLogout } from "../../../Utils/Logout";
// import { TriangleAlert } from "lucide-react";

// const PopularProducts = () => {
//     const [products, setProducts] = useState([]);
//     const [topRatedProducts, setTopRatedProducts] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [loadingWishlistItems, setLoadingWishlistItems] = useState({});
//     const [showLoginModal, setShowLoginModal] = useState(false);
//     const [productToAdd, setProductToAdd] = useState(null);
//     const [imageErrors, setImageErrors] = useState({});
//     const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
//     const [isTablet, setIsTablet] = useState(window.innerWidth >= 768 && window.innerWidth < 1024);
//     const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);
//     const [slidesToShowDesktop, setSlidesToShowDesktop] = useState(4);

//     const navigate = useNavigate();
//     const dispatch = useDispatch();
//     const token = Cookies.get("ecom_user_token");
//     const cartItems = useSelector((state) => state.cart.items);
//     const { items: wishlist, loading: wishlistLoading } = useSelector(
//         (state) => state.wishlist
//     );

//     // Handle window resize for responsive design
//     useEffect(() => {
//         const handleResize = () => {
//             setIsMobile(window.innerWidth < 768);
//             setIsTablet(window.innerWidth >= 768 && window.innerWidth < 1024);
//             setIsDesktop(window.innerWidth >= 1024);
//         };

//         window.addEventListener('resize', handleResize);
//         return () => window.removeEventListener('resize', handleResize);
//     }, []);


//     useEffect(() => {
//         const updateSlides = () => {
//             const containerWidth = window.innerWidth - 64; // subtract padding/margins
//             const possibleSlides = Math.floor(containerWidth / 326);
//             setSlidesToShowDesktop(possibleSlides >= 1 ? possibleSlides : 1);
//         };

//         updateSlides();
//         window.addEventListener('resize', updateSlides);
//         return () => window.removeEventListener('resize', updateSlides);
//     }, []);

//     // Custom arrow components with responsive adjustments
//     const NextArrow = (props) => {
//         const { className, style, onClick } = props;
//         return (
//             <div
//                 className={`${className} custom-slick-arrow`}
//                 style={{
//                     ...style,
//                     display: "block",
//                     right: isMobile ? "-10px" : isTablet ? "-15px" : "-25px",
//                     width: isMobile ? "30px" : "40px",
//                     height: isMobile ? "30px" : "40px",
//                     zIndex: 1,
//                 }}
//                 onClick={onClick}
//             >
//                 <div className="w-full h-full bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-blue-50 transition-colors duration-200 border border-gray-200">
//                     <AiOutlineRight className="text-gray-700 text-lg md:text-xl" />
//                 </div>
//             </div>
//         );
//     };

//     const PrevArrow = (props) => {
//         const { className, style, onClick } = props;
//         return (
//             <div
//                 className={`${className} custom-slick-arrow`}
//                 style={{
//                     ...style,
//                     display: "block",
//                     left: isMobile ? "-10px" : isTablet ? "-15px" : "-25px",
//                     width: isMobile ? "30px" : "40px",
//                     height: isMobile ? "30px" : "40px",
//                     zIndex: 1,
//                 }}
//                 onClick={onClick}
//             >
//                 <div className="w-full h-full bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-blue-50 transition-colors duration-200 border border-gray-200">
//                     <AiOutlineLeft className="text-gray-700 text-lg md:text-xl" />
//                 </div>
//             </div>
//         );
//     };

//     // Slider settings with improved responsive breakpoints
//     const sliderSettings = {
//         dots: isMobile,
//         infinite: true,
//         speed: 650,
//         cssEase: "cubic-bezier(0.4, 0, 0.2, 1)",
//         swipeToSlide: true,
//         touchThreshold: 10,
//         slidesToShow: isMobile ? 1 : isTablet ? 2 : slidesToShowDesktop,
//         slidesToScroll: isMobile ? 1 : isTablet ? 1 : 2,
//         nextArrow: <NextArrow />,
//         prevArrow: <PrevArrow />,
//         responsive: [
//             {
//                 breakpoint: 1024,
//                 settings: {
//                     slidesToShow: 2,
//                     slidesToScroll: 1,
//                     infinite: true,
//                     dots: true,
//                 },
//             },
//             {
//                 breakpoint: 768,
//                 settings: {
//                     slidesToShow: 1,
//                     slidesToScroll: 1,
//                     dots: false,
//                     arrows: !isMobile,
//                 },
//             },
//             {
//                 breakpoint: 480,
//                 settings: {
//                     slidesToShow: 1,
//                     slidesToScroll: 1,
//                     dots: false,
//                     arrows: false,
//                 },
//             },
//         ],
//     };

//     useEffect(() => {
//         if (token) {
//             dispatch(fetchWishlist());
//         }
//     }, [token, dispatch]);

//     useEffect(() => {
//         dispatch(fetchCart());
//     }, [dispatch]);

//     const handleImageError = (productId) => {
//         setImageErrors((prev) => ({
//             ...prev,
//             [productId]: true,
//         }));
//     };

//     const getProductImage = (product) => {
//         if (imageErrors[product._id]) {
//             return fallbackImage;
//         }
//         return (
//             product.variants?.[0]?.images?.[0] || product.images?.[0] || fallbackImage
//         );
//     };

//     useEffect(() => {
//         const fetchTopRatedProducts = async () => {
//             try {
//                 const response = await axios.get(
//                     `${process.env.REACT_APP_BACKEND_URL}/api/seller/product/get-by-rating`
//                 );

//                 // Process products to find active variants only
//                 const processedProducts = response?.data?.products
//                     ?.map((item) => {
//                         const product = item.product;

//                         // Filter out non-active variants
//                         const activeVariants = product.variants?.filter(
//                             (v) => v.status === "active"
//                         );

//                         if (activeVariants.length === 0) return null; // Skip products with no active variants

//                         // Create a new product object with only active variants
//                         return {
//                             ...item,
//                             product: {
//                                 ...product,
//                                 variants: activeVariants,
//                                 // Add a flag to indicate if the product is in stock
//                                 isInStock: activeVariants.some(
//                                     (v) => v.stock > 0 || v.stock === undefined
//                                 ),
//                             },
//                         };
//                     })
//                     .filter(Boolean); // Remove null entries

//                 // Sort products by rating (highest first) and then by number of ratings
//                 const sortedProducts = processedProducts.sort((a, b) => {
//                     if (b.averageRating !== a.averageRating) {
//                         return b.averageRating - a.averageRating;
//                     }
//                     return b.ratingCount - a.ratingCount;
//                 });

//                 setProducts(sortedProducts);
//                 // Take top 5 products for the slider
//                 setTopRatedProducts(sortedProducts.slice(0, 5));
//                 setLoading(false);
//             } catch (err) {
//                 globalLogout(err)
//                 setError(err.message);
//                 setLoading(false);
//                 console.error("Error fetching top rated products:", err);
//             }
//         };

//         fetchTopRatedProducts();
//     }, []);

//     const fetchProductDetails = (slug) => {
//         navigate(`/product/${slug}`);
//     };

//     const handleAddToCart = async (product, e) => {
//         e.stopPropagation();

//         if (!token) {
//             setProductToAdd(product);
//             setShowLoginModal(true);
//             return;
//         }

//         const firstVariantId = product.variants?.[0]?._id;

//         if (!product.isInStock) {
//             toast.warning("This item is out of stock");
//             return;
//         }

//         try {
//             await dispatch(
//                 addToCart({
//                     productId: product._id,
//                     variantId: product.variants?.length > 0 ? firstVariantId : undefined,
//                     quantity: 1,
//                 })
//             );
//             toast.success("Added to cart!");
//         } catch (error) {
//             console.error("Add to cart failed:", error);
//             toast.error(error.response?.data?.message || "Failed to add to cart");
//         }
//     };

//     const confirmAddToCart = async () => {
//         setShowLoginModal(false);
//         navigate("/login", { state: { from: window.location.pathname } });
//     };

//     const handleQuantityChange = async (productId, newQuantity, e) => {
//         e.stopPropagation();
//         const product = products.find((p) => p.product._id === productId)?.product;
//         const firstVariantId = product?.variants?.[0]?._id;

//         try {
//             await dispatch(
//                 updateItemQuantity({
//                     productId,
//                     variantId: product?.variants?.length > 0 ? firstVariantId : undefined,
//                     quantity: newQuantity,
//                 })
//             );
//         } catch (error) {
//             console.error("Error updating quantity:", error);
//             alert(error.response?.data?.message);
//             toast.error(error.response?.data?.message || "Failed to add to cart");
//         }
//     };

//     const toggleWishlist = async (productId, variantId, e) => {
//         e.stopPropagation();
//         if (!token) {
//             toast.info("Please login to manage your wishlist");
//             navigate("/login");
//             return;
//         }

//         try {
//             setLoadingWishlistItems((prev) => ({ ...prev, [productId]: true }));

//             const isInWishlist = wishlist.some(
//                 (item) =>
//                     item.productId._id === productId && item.variantId === variantId
//             );

//             if (isInWishlist) {
//                 await dispatch(removeItemFromWishlist(productId, variantId));
//                 toast.success("Removed from wishlist");
//             } else {
//                 await dispatch(addItemToWishlist(productId, variantId));
//                 toast.success("Added to wishlist");
//             }
//         } catch (error) {
//             console.error("Wishlist operation failed:", error);
//             toast.error(
//                 error.response?.data?.message ||
//                 "Failed to update wishlist. Please try again."
//             );
//         } finally {
//             setLoadingWishlistItems((prev) => ({ ...prev, [productId]: false }));
//         }
//     };

//     const renderProductActions = (product) => {
//         const firstVariant = product.variants?.[0];
//         const firstVariantId = firstVariant?._id;

//         if (!product.isInStock) {
//             return (
//                 <button
//                     className="px-3 py-1.5 text-xs md:px-4 md:py-2 md:text-sm rounded-full bg-gray-300 text-gray-600 cursor-not-allowed font-medium"
//                     disabled
//                 >
//                     Out of Stock
//                 </button>
//             );
//         }

//         const cartItem = cartItems.find(
//             (item) =>
//                 item.productId === product._id &&
//                 (product.variants?.length > 0
//                     ? item.variantId === firstVariantId
//                     : true)
//         );

//         if (cartItem) {
//             return (
//                 <div className="flex items-center justify-center space-x-1 md:space-x-2">
//                     <button
//                         className={`w-6 h-6 md:w-8 md:h-8 flex items-center justify-center rounded-full transition-all duration-200 shadow-sm ${cartItem.quantity <= 0
//                             ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                             : "bg-gradient-to-b from-gray-100 to-gray-200 hover:from-gray-200 hover:to-gray-300 text-gray-700 hover:text-gray-900 hover:shadow-md"
//                             }`}
//                         onClick={(e) => {
//                             const newQuantity = cartItem.quantity - 1;
//                             handleQuantityChange(product._id, newQuantity, e);
//                         }}
//                         disabled={cartItem.quantity <= 0}
//                     >
//                         <span className="text-sm md:text-lg font-medium">−</span>
//                     </button>
//                     <span className="w-6 text-center font-medium text-gray-700 text-sm md:text-base md:w-8">
//                         {cartItem.quantity}
//                     </span>
//                     <button
//                         className={`w-6 h-6 md:w-8 md:h-8 flex items-center justify-center rounded-full bg-gradient-to-b from-blue-100 to-blue-200 hover:from-blue-200 hover:to-blue-300 text-blue-700 hover:text-blue-900 transition-all duration-200 shadow-sm hover:shadow-md ${!product.isInStock ? "opacity-50 cursor-not-allowed" : ""
//                             }`}
//                         onClick={(e) =>
//                             handleQuantityChange(product._id, cartItem.quantity + 1, e)
//                         }
//                         disabled={!product.isInStock}
//                     >
//                         <span className="text-sm md:text-lg font-medium">+</span>
//                     </button>
//                 </div>
//             );
//         } else {
//             return (
//                 <button
//                     className={`
//                         flex items-center justify-center
//                         px-3 py-1.5 md:px-4 md:py-2 
//                         bg-[#2D1B0E] text-[#FDFBF7] 
//                         rounded-sm text-[9px] md:text-[11px] font-bold uppercase tracking-[0.15em]
//                         transition-all duration-200
//                         border-b-2 border-[#1A0F08] 
//                         active:border-b-0 active:translate-y-[2px]
//                         shadow-md
//                         ${!product.isInStock
//                             ? "opacity-40 cursor-not-allowed grayscale"
//                             : "hover:bg-[#3D2614] hover:shadow-[#2D1B0E]/10"}
//                     `}
//                     onClick={(e) => handleAddToCart(product, e)}
//                     disabled={!product.isInStock}
//                 >
//                     <AiOutlineShoppingCart className="mr-1 md:mr-2 text-sm md:text-base" />
//                     Add to Cart
//                 </button>
//             );
//         }
//     };

//     const renderRatingStars = (rating) => {
//         const stars = [];
//         const fullStars = Math.floor(rating);
//         const hasHalfStar = rating % 1 >= 0.5;

//         for (let i = 0; i < fullStars; i++) {
//             stars.push(<BsStarFill key={`full-${i}`} className="text-yellow-400 text-xs md:text-sm" />);
//         }

//         if (hasHalfStar) {
//             stars.push(<BsStarHalf key="half" className="text-yellow-400 text-xs md:text-sm" />);
//         }

//         const emptyStars = 5 - stars.length;
//         for (let i = 0; i < emptyStars; i++) {
//             stars.push(<BsStar key={`empty-${i}`} className="text-yellow-400 text-xs md:text-sm" />);
//         }

//         return stars;
//     };

//     if (loading) {
//         return (
//             <div className="flex justify-center items-center h-64 md:h-96">
//                 <PulseLoader color="#3B82F6" size={15} />
//             </div>
//         );
//     }

//     if (error) {
//         return (
//             <div className="text-red-500 text-center p-4 md:p-10 bg-red-50 rounded-xl max-w-3xl mx-auto my-8 md:my-12">
//                 <h3 className="text-lg md:text-xl font-bold mb-2">Error Loading Products</h3>
//                 <p className="text-sm md:text-base">{error}</p>
//                 <p className="mt-2 md:mt-4 text-sm md:text-base">Please try again later</p>
//             </div>
//         );
//     }

//     if (topRatedProducts.length === 0) {
//         return (
//             <div className="text-gray-600 text-center p-4 md:p-10 bg-gray-50 rounded-xl max-w-3xl mx-auto my-8 md:my-12">
//                 <h3 className="text-xl md:text-2xl font-bold mb-4">No Top Rated Products Found</h3>
//                 <p className="text-sm md:text-base">
//                     We couldn't find any products with active variants and a 4+ star rating at the moment.
//                 </p>
//             </div>
//         );
//     }

//     return (
//         <section className="py-8 md:py-16">
//             {/* Login Confirmation Modal */}
//             {showLoginModal && (
//                 <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//                     <div className="bg-white rounded-lg p-4 md:p-6 max-w-md w-full mx-4">
//                         <div className="flex items-center justify-center py-3">
//                             <TriangleAlert className="w-20 h-20 text-yellow-400" />
//                         </div>
//                         <h3 className="text-2xl text-center font-bold text-gray-900 mb-4">
//                             Login Required
//                         </h3>
//                         <p className="text-gray-600 mb-6 text-sm md:text-base">
//                             You need to login to add items to your cart. Would you like to
//                             login now?
//                         </p>
//                         <div className="flex justify-end space-x-3 md:space-x-4">
//                             <button
//                                 onClick={() => setShowLoginModal(false)}
//                                 className="px-3 py-2 md:px-4 md:py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 text-sm md:text-base"
//                             >
//                                 Cancel
//                             </button>
//                             <button
//                                 onClick={confirmAddToCart}
//                                 className="px-3 py-2 md:px-4 md:py-2 bg-yellow-800 text-white rounded-md hover:bg-yellow-900 text-sm md:text-base"
//                             >
//                                 Login
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             <div className="container mx-auto px-3 md:px-4">
//                 <div className="text-center my-6 md:my-10 animate-in fade-in slide-in-from-bottom-4 duration-1000">
//                     <h2 className="text-xl md:text-3xl font-serif text-stone-900 leading-tight">
//                         Popular <span className="italic font-light text-yellow-900">Products</span>
//                     </h2>

//                     {/* Decorative Divider Line */}
//                     {/* <div className="flex items-center justify-center gap-4 mb-6">
//                         <div className="h-[1px] w-12 bg-stone-300"></div>
//                         <div className="text-stone-300">✦</div>
//                         <div className="h-[1px] w-12 bg-stone-300"></div>
//                     </div> */}
//                 </div>


//                 <div className="px-1 md:px-4 relative">
//                     <Slider {...sliderSettings}>
//                         {topRatedProducts.map((item, index) => {
//                             const product = item.product;
//                             const firstVariant = product.variants?.[0];
//                             const firstVariantId = firstVariant?._id;
//                             const productImage = getProductImage(product);

//                             return (
//                                 <div key={product._id} className="px-1 pb-4">
//                                     <div
//                                         className="group bg-[#FDFBF7] border border-stone-200 overflow-hidden hover:border-yellow-900/30 transition-all duration-500 relative h-full flex flex-col shadow-sm hover:shadow-2xl"
//                                         onClick={() => fetchProductDetails(product.slug)}
//                                     >
//                                         {/* Wood Grain Overlay Effect (Optional) */}
//                                         <div className="absolute inset-0 opacity-[0.02] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/wood-pattern.png')]"></div>

//                                         {/* Status Badge (Best Seller/Popular) - Styled like a leather tag or brass plate */}
//                                         {index < 2 && (
//                                             <div className="absolute top-0 left-6 z-10">
//                                                 <div className="bg-yellow-900 text-[#FDFBF7] px-3 py-2 text-[10px] font-bold uppercase tracking-[0.2em] shadow-md flex flex-col items-center">
//                                                     <span className="leading-none">{index === 0 ? "Best" : "Top"}</span>
//                                                     <div className="h-[1px] w-full bg-[#FDFBF7]/30 my-1"></div>
//                                                     <span className="leading-none">{index === 0 ? "Seller" : "Rated"}</span>
//                                                 </div>
//                                             </div>
//                                         )}

//                                         {/* Wishlist Button - Minimalist Brass Style */}
//                                         {token && (
//                                             <button
//                                                 onClick={(e) => toggleWishlist(product._id, firstVariantId, e)}
//                                                 disabled={loadingWishlistItems[product._id]}
//                                                 className="absolute top-4 right-4 z-10 p-2.5 rounded-full bg-[#FDFBF7] border border-stone-100 text-stone-400 hover:text-red-800 hover:border-red-100 transition-all duration-300 shadow-sm"
//                                             >
//                                                 {loadingWishlistItems[product._id] ? (
//                                                     <PulseLoader size={3} color="#78350f" />
//                                                 ) : wishlist.some(item => item?.productId?._id === product?._id) ? (
//                                                     <AiFillHeart className="h-5 w-5 text-red-800" />
//                                                 ) : (
//                                                     <AiOutlineHeart className="h-5 w-5" />
//                                                 )}
//                                             </button>
//                                         )}

//                                         {/* Product Image Area */}
//                                         <div className="relative h-56 md:h-72 w-full overflow-hidden bg-[#F9F6F1] flex items-center justify-center p-6">
//                                             <img
//                                                 src={productImage}
//                                                 alt={product.name}
//                                                 className="max-h-full max-w-full object-contain transition-transform duration-700 group-hover:scale-110"
//                                                 onError={() => handleImageError(product._id)}
//                                                 loading="lazy"
//                                             />

//                                             {/* Out of Stock Overlay */}
//                                             {!product.isInStock && (
//                                                 <div className="absolute inset-0 bg-stone-900/40 backdrop-blur-[2px] flex items-center justify-center">
//                                                     <span className="border-2 border-[#FDFBF7] text-[#FDFBF7] px-4 py-2 text-xs font-bold uppercase tracking-widest">
//                                                         Sold Out
//                                                     </span>
//                                                 </div>
//                                             )}
//                                         </div>

//                                         {/* Product Info */}
//                                         <div className="p-3 md:p-5 flex-grow flex flex-col bg-white">
//                                             <div className="flex justify-between items-start mb-4">
//                                                 <div className="flex-1">
//                                                     <h3 className="text-lg md:text-xl font-serif text-stone-900 mb-1 line-clamp-1 group-hover:text-yellow-900 transition-colors">
//                                                         {product.name}
//                                                     </h3>
//                                                     <div className="flex items-center gap-2">
//                                                         <div className="flex text-yellow-700 text-xs">
//                                                             {renderRatingStars(item.averageRating)}
//                                                         </div>
//                                                         <span className="text-[10px] uppercase tracking-tighter text-stone-400 font-bold">
//                                                             ({item.ratingCount} Reviews)
//                                                         </span>
//                                                     </div>
//                                                 </div>
//                                                 <div className="text-right">
//                                                     <div className="text-lg md:text-xl font-bold text-stone-900">
//                                                         ₹{firstVariant?.price?.toLocaleString()}
//                                                     </div>
//                                                     {firstVariant?.mrp > firstVariant?.price && (
//                                                         <div className="text-xs text-stone-400 line-through decoration-red-800/30">
//                                                             ₹{firstVariant?.mrp?.toLocaleString()}
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             </div>

//                                             <p className="text-stone-500 mb-6 line-clamp-2 text-xs md:text-sm leading-relaxed italic font-light">
//                                                 {product.description}
//                                             </p>

//                                             {/* Availability & Action Row */}
//                                             <div className="flex justify-between items-center mt-auto pt-4 border-t border-stone-100">
//                                                 <div className="flex items-center gap-2">
//                                                     <span className={`w-1.5 h-1.5 rounded-full ${!product.isInStock ? 'bg-red-800' :
//                                                         firstVariant?.stock < 5 ? 'bg-orange-600 animate-pulse' : 'bg-green-700'
//                                                         }`}></span>
//                                                     <span className="text-[10px] uppercase font-bold tracking-widest text-stone-500">
//                                                         {!product.isInStock ? "Restocking" : firstVariant?.stock < 5 ? "Limited" : "Available"}
//                                                     </span>
//                                                 </div>

//                                                 <div className="transform translate-y-2 group-hover:translate-y-0 transition-all duration-300">
//                                                     {renderProductActions(product)}
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             );
//                         })}
//                     </Slider>
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default PopularProducts;


















import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    updateItemQuantity,
    addToCart,
    fetchCart,
} from "../../../redux/thunks/cartThunks";
import {
    fetchWishlist,
    addItemToWishlist,
    removeItemFromWishlist,
} from "../../../redux/thunks/wishlistThunks";
import { BsStarFill } from "react-icons/bs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PulseLoader } from "react-spinners";
import fallbackImage from "../../../assets/brand-default.jpg";
import { globalLogout } from "../../../Utils/Logout";
import { Heart, ShoppingCart, TriangleAlert } from "lucide-react";

/* Seller descriptions are stored as HTML -> turn into one line of plain text.
   DOMParser never runs scripts, and it decodes entities (&amp; etc.) for us. */
export const htmlToText = (html) => {
    if (!html) return "";
    const spaced = String(html)
        .replace(/<\s*br\s*\/?>/gi, " ")
        .replace(/<\/(p|div|li|h[1-6]|tr|ul|ol)>/gi, " ");
    const doc = new DOMParser().parseFromString(spaced, "text/html");
    return (doc.body.textContent || "").replace(/\s+/g, " ").trim();
};

const PopularProducts = () => {
    const [topRatedProducts, setTopRatedProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [loadingWishlistItems, setLoadingWishlistItems] = useState({});
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [imageErrors, setImageErrors] = useState({});

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const token = Cookies.get("ecom_user_token");
    const cartItems = useSelector((state) => state.cart.items);
    const { items: wishlist } = useSelector((state) => state.wishlist);

    useEffect(() => {
        if (token) {
            dispatch(fetchWishlist());
            dispatch(fetchCart());
        }
    }, [token, dispatch]);

    useEffect(() => {
        const fetchTopRatedProducts = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/seller/product/get-by-rating`
                );

                const processed = (response?.data?.products || [])
                    .map((item) => {
                        const product = item.product;
                        const activeVariants = (product.variants || []).filter((v) => v.status === "active");
                        if (activeVariants.length === 0) return null;
                        return {
                            ...item,
                            product: {
                                ...product,
                                variants: activeVariants,
                                isInStock: activeVariants.some((v) => v.stock > 0 || v.stock === undefined),
                            },
                        };
                    })
                    .filter(Boolean)
                    .sort((a, b) =>
                        b.averageRating !== a.averageRating
                            ? b.averageRating - a.averageRating
                            : b.ratingCount - a.ratingCount
                    );

                setTopRatedProducts(processed.slice(0, 5));
            } catch (err) {
                globalLogout(err);
                setError(err.message);
                console.error("Error fetching top rated products:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchTopRatedProducts();
    }, []);

    const getProductImage = (product) => {
        if (imageErrors[product._id]) return fallbackImage;
        return product.variants?.[0]?.images?.[0] || product.images?.[0] || fallbackImage;
    };

    const isWishlisted = (productId, variantId) =>
        wishlist.some(
            (item) => item?.productId?._id === productId && item?.variantId === variantId
        );

    const getCartItem = (product) => {
        const variantId = product.variants?.[0]?._id;
        return cartItems.find(
            (item) =>
                item.productId === product._id &&
                (product.variants?.length > 0 ? item.variantId === variantId : true)
        );
    };

    const handleAddToCart = async (product) => {
        if (!token) {
            setShowLoginModal(true);
            return;
        }
        if (!product.isInStock) {
            toast.warning("This item is out of stock");
            return;
        }
        try {
            await dispatch(
                addToCart({
                    productId: product._id,
                    variantId: product.variants?.[0]?._id,
                    quantity: 1,
                })
            );
            toast.success("Added to cart!");
        } catch (err) {
            console.error("Add to cart failed:", err);
            toast.error(err.response?.data?.message || "Failed to add to cart");
        }
    };

    const handleQuantityChange = async (product, newQuantity) => {
        try {
            await dispatch(
                updateItemQuantity({
                    productId: product._id,
                    variantId: product.variants?.[0]?._id,
                    quantity: newQuantity,
                })
            );
        } catch (err) {
            console.error("Error updating quantity:", err);
            toast.error(err.response?.data?.message || "Failed to update cart");
        }
    };

    const toggleWishlist = async (productId, variantId) => {
        if (!token) {
            toast.info("Please login to manage your wishlist");
            navigate("/login");
            return;
        }
        try {
            setLoadingWishlistItems((prev) => ({ ...prev, [productId]: true }));
            if (isWishlisted(productId, variantId)) {
                await dispatch(removeItemFromWishlist(productId, variantId));
                toast.success("Removed from wishlist");
            } else {
                await dispatch(addItemToWishlist(productId, variantId));
                toast.success("Added to wishlist");
            }
        } catch (err) {
            console.error("Wishlist operation failed:", err);
            toast.error(err.response?.data?.message || "Failed to update wishlist. Please try again.");
        } finally {
            setLoadingWishlistItems((prev) => ({ ...prev, [productId]: false }));
        }
    };

    const renderAction = (product) => {
        if (!product.isInStock) {
            return (
                <button
                    disabled
                    className="w-full py-2 rounded-md bg-gray-100 text-gray-400 text-xs sm:text-sm font-semibold cursor-not-allowed"
                >
                    Out of Stock
                </button>
            );
        }

        const cartItem = getCartItem(product);

        if (cartItem) {
            return (
                <div className="flex items-center justify-between rounded-md border border-yellow-800 overflow-hidden">
                    <button
                        type="button"
                        aria-label="Decrease quantity"
                        onClick={() => handleQuantityChange(product, cartItem.quantity - 1)}
                        className="w-10 h-8 sm:h-9 text-lg text-yellow-800 hover:bg-yellow-50"
                    >
                        −
                    </button>
                    <span className="text-sm font-semibold text-gray-800">{cartItem.quantity}</span>
                    <button
                        type="button"
                        aria-label="Increase quantity"
                        onClick={() => handleQuantityChange(product, cartItem.quantity + 1)}
                        className="w-10 h-8 sm:h-9 text-lg text-yellow-800 hover:bg-yellow-50"
                    >
                        +
                    </button>
                </div>
            );
        }

        return (
            <button
                type="button"
                onClick={() => handleAddToCart(product)}
                className="w-full flex items-center justify-center gap-1.5 py-2 rounded-md border border-yellow-800 text-yellow-800 text-xs sm:text-sm font-semibold hover:bg-yellow-50 transition-colors"
            >
                <ShoppingCart size={15} />
                Add to Cart
            </button>
        );
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center h-48">
                <PulseLoader color="#854d0e" size={12} />
            </div>
        );
    }

    if (error) {
        return (
            <div className="text-center p-6 bg-red-50 rounded-lg max-w-2xl mx-auto my-8">
                <h3 className="text-base font-semibold text-red-600 mb-1">Couldn't load products</h3>
                <p className="text-sm text-red-500">Please try again later.</p>
            </div>
        );
    }

    if (topRatedProducts.length === 0) return null;

    return (
        <section className="w-full">
            {/* Login prompt */}
            {showLoginModal && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-lg p-5 md:p-6 max-w-sm w-full">
                        <div className="flex items-center justify-center pb-2">
                            <TriangleAlert className="w-14 h-14 text-yellow-500" />
                        </div>
                        <h3 className="text-lg text-center font-semibold text-gray-900 mb-2">Login required</h3>
                        <p className="text-gray-600 mb-5 text-sm text-center">
                            You need to login to add items to your cart. Would you like to login now?
                        </p>
                        <div className="flex gap-3">
                            <button
                                onClick={() => setShowLoginModal(false)}
                                className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 text-sm"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={() => {
                                    setShowLoginModal(false);
                                    navigate("/login", { state: { from: window.location.pathname } });
                                }}
                                className="flex-1 px-4 py-2 bg-yellow-800 text-white rounded-md hover:bg-yellow-900 text-sm font-medium"
                            >
                                Login
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <h2 className="text-lg font-semibold text-gray-900 mb-4">Popular Products</h2>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4">
                {topRatedProducts.map((item, index) => {
                    const product = item.product;
                    const variant = product.variants?.[0];
                    const description = htmlToText(product.description);
                    const hasDiscount = variant?.mrp > variant?.price;
                    const discount = hasDiscount
                        ? Math.round((1 - variant.price / variant.mrp) * 100)
                        : 0;

                    return (
                        <article
                            key={product._id}
                            className="relative flex flex-col bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-md hover:border-yellow-800/40 transition-all"
                        >
                            {/* Wishlist */}
                            {token && variant && (
                                <button
                                    type="button"
                                    aria-label="Wishlist"
                                    onClick={() => toggleWishlist(product._id, variant._id)}
                                    disabled={loadingWishlistItems[product._id]}
                                    className="absolute top-2 right-2 z-10 w-8 h-8 rounded-full bg-white/90 border border-gray-200 flex items-center justify-center text-gray-500 hover:text-red-500 shadow-sm"
                                >
                                    {loadingWishlistItems[product._id] ? (
                                        <PulseLoader size={3} color="#854d0e" />
                                    ) : (
                                        <Heart
                                            size={16}
                                            className={isWishlisted(product._id, variant._id) ? "text-red-500" : ""}
                                            fill={isWishlisted(product._id, variant._id) ? "currentColor" : "none"}
                                        />
                                    )}
                                </button>
                            )}

                            <Link to={`/product/${product.slug}`} className="flex flex-col flex-1">
                                {/* Image */}
                                <div className="relative h-64 aspect-square bg-gray-50 flex items-center justify-center">
                                    <img
                                        src={getProductImage(product)}
                                        alt={product.name}
                                        loading="lazy"
                                        onError={() => setImageErrors((prev) => ({ ...prev, [product._id]: true }))}
                                        className={`w-full h-full object-contain p-3 ${!product.isInStock ? "grayscale opacity-60" : ""}`}
                                    />
                                    {index < 2 && product.isInStock && (
                                        <span className="absolute top-0 left-0 bg-yellow-800 text-white text-[10px] font-semibold px-2 py-1 rounded-br-md">
                                            {index === 0 ? "Best Seller" : "Top Rated"}
                                        </span>
                                    )}
                                    {!product.isInStock && (
                                        <span className="absolute bottom-2 left-2 bg-gray-800 text-white text-[10px] font-medium px-2 py-0.5 rounded">
                                            Sold out
                                        </span>
                                    )}
                                </div>

                                {/* Info */}
                                <div className="p-3 flex flex-col gap-1.5 flex-1">
                                    <h3 className="text-sm font-medium text-gray-800 line-clamp-1">{product.name}</h3>

                                    {/* Plain-text description, max 2 lines then "..." */}
                                    <p className="text-xs text-gray-500 leading-4 line-clamp-2 min-h-[2rem]">
                                        {description}
                                    </p>

                                    <div className="flex items-baseline flex-wrap gap-x-2">
                                        <span className="text-base font-bold text-gray-900">
                                            ₹{variant?.price?.toLocaleString("en-IN")}
                                        </span>
                                        {hasDiscount && (
                                            <>
                                                <span className="text-xs text-gray-400 line-through">
                                                    ₹{variant.mrp.toLocaleString("en-IN")}
                                                </span>
                                                <span className="text-xs font-semibold text-green-600">{discount}% off</span>
                                            </>
                                        )}
                                    </div>

                                    <div className="flex items-center gap-1.5 mt-auto">
                                        <span className="inline-flex items-center gap-1 rounded-full bg-green-600 text-white text-[11px] font-semibold px-2 py-0.5">
                                            {Number(item.averageRating || 0).toFixed(1)}
                                            <BsStarFill className="text-[9px]" />
                                        </span>
                                        <span className="text-[11px] text-gray-500">({item.ratingCount})</span>
                                    </div>
                                </div>
                            </Link>

                            {/* Cart action (outside the Link so clicks don't navigate) */}
                            <div className="px-3 pb-3">{renderAction(product)}</div>
                        </article>
                    );
                })}
            </div>
        </section>
    );
};

export default PopularProducts;